import { __extends } from "tslib";
var __assign = (this && this.__assign) || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [0, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injector } from '@angular/core';
import * as moment from 'moment';
import { CompModel } from '@apto/models';
import { END_POINTS, SERVICE_NAMES } from '../constants';
import { BaseService } from '../base/base-service';
import { AlertController } from 'ionic-angular';
var CompsService = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(CompsService, _super);
    function CompsService(injector, alertController) {
        var _this = _super.call(this, injector, alertController) || this;
        _this.injector = injector;
        _this.alertController = alertController;
        _this.endpoint = _this.configService.serviceUrl + "/" + END_POINTS.COMPS;
        _this.model = CompModel;
        _this.serviceName = SERVICE_NAMES.COMPS;
        return _this;
    }
    /**
     * Sort by expired leases, unexpired leases, then leases without expiration dates.
     * Sort by expiration date for leases with expiration dates, or by created date for leases without expiration dates.
     */
    CompsService.sortLeases = function (leases) {
        if (!leases) {
            return [];
        }
        return leases.sort(function (a, b) {
            if (!a.leaseExpirationDate && !b.leaseExpirationDate) {
                if (a.createdDate < b.createdDate) {
                    return -1;
                }
                else if (a.createdDate > b.createdDate) {
                    return 1;
                }
            }
            else if (!a.leaseExpirationDate && b.leaseExpirationDate) {
                return 1;
            }
            else if (a.leaseExpirationDate && !b.leaseExpirationDate) {
                return -1;
            }
            else if (CompsService.leaseIsExpired(a) && !CompsService.leaseIsExpired(b)) {
                return -1;
            }
            else if (!CompsService.leaseIsExpired(a) && CompsService.leaseIsExpired(b)) {
                return 1;
            }
            else if (a.leaseExpirationDate < b.leaseExpirationDate) {
                return -1;
            }
            else if (a.leaseExpirationDate > b.leaseExpirationDate) {
                return 1;
            }
            return 0;
        });
    };
    /**
     * Sort by unexpired leases, no expiration dates, expired leases
     */
    CompsService.sortLeasesCurrentFirst = function (leases) {
        if (!leases) {
            return [];
        }
        return leases.sort(function (a, b) {
            if (CompsService.leaseIsExpired(a) && !CompsService.leaseIsExpired(b)) {
                return 1;
            }
            else if (!CompsService.leaseIsExpired(a) && CompsService.leaseIsExpired(b)) {
                return -1;
            }
            else if (!a.leaseExpirationDate && !b.leaseExpirationDate) {
                if (a.createdDate < b.createdDate) {
                    return -1;
                }
                else if (a.createdDate > b.createdDate) {
                    return 1;
                }
            }
            else if (!a.leaseExpirationDate && b.leaseExpirationDate) {
                return -1;
            }
            else if (a.leaseExpirationDate && !b.leaseExpirationDate) {
                return 1;
            }
            else if (a.leaseExpirationDate < b.leaseExpirationDate) {
                return -1;
            }
            else if (a.leaseExpirationDate > b.leaseExpirationDate) {
                return 1;
            }
            return 0;
        });
    };
    CompsService.leaseIsExpired = function (comp) {
        if (!comp || !comp.leaseExpirationDate) {
            return true;
        }
        return moment(comp.leaseExpirationDate).endOf('day').isBefore(moment.now());
    };
    CompsService.prototype.byLandlordOrTenant = function (contactId, companyId, withCompany) {
        if (contactId === void 0) {
            contactId = null;
        }
        if (companyId === void 0) {
            companyId = null;
        }
        if (withCompany === void 0) {
            withCompany = true;
        }
        var ors = [];
        if (contactId) {
            ors.push({ landlordContactId: contactId });
            ors.push({ tenantContactId: contactId });
        }
        if (companyId && withCompany) {
            ors.push({ landlordCompanyId: companyId });
            ors.push({ tenantCompanyId: companyId });
        }
        return this.fetch({
            where: {
                $or: ors
            }
        });
    };
    CompsService.prototype.bySoldProperties = function (propertyIds) {
        var _this = this;
        var uncachedPropertyIds = propertyIds.filter(function (propertyId) { return !_this.cacheService.get(_this.serviceName, propertyId); });
        var cachedComps = this.cacheService.getAll(this.serviceName)
            .filter(function (comp) { return comp.soldPropertyId && propertyIds.indexOf(comp.soldPropertyId) !== -1; });
        if (!uncachedPropertyIds.length) {
            return Promise.resolve(cachedComps);
        }
        var params = {
            where: {
                soldPropertyId: {
                    $in: uncachedPropertyIds
                }
            }
        };
        return this.fetch(params)
            .then(function (comps) {
            // flag that we have already queried all comps for each property id
            uncachedPropertyIds.forEach(function (propertyId) { return _this.cacheService.add(_this.serviceName, propertyId, true); });
            return cachedComps.concat(comps);
        });
    };
    CompsService.prototype.bySoldOrLeasedProperties = function (propertyIds) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var uncachedPropertyIds, cachedComps, params, comps;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uncachedPropertyIds = propertyIds.filter(function (propertyId) { return !_this.cacheService.get(_this.serviceName, propertyId); });
                        cachedComps = this.cacheService.getAll(this.serviceName).filter(function (comp) {
                            return (comp.soldPropertyId && propertyIds.includes(comp.soldPropertyId)) ||
                                (comp.leasedPropertyId && propertyIds.includes(comp.leasedPropertyId));
                        });
                        if (!uncachedPropertyIds.length) {
                            return [2 /*return*/, Promise.resolve(cachedComps)];
                        }
                        params = {
                            where: {
                                $or: [
                                    { soldPropertyId: { $in: uncachedPropertyIds } },
                                    { leasedPropertyId: { $in: uncachedPropertyIds } }
                                ]
                            }
                        };
                        return [4 /*yield*/, this.fetch(params)];
                    case 1:
                        comps = _a.sent();
                        uncachedPropertyIds.forEach(function (propertyId) { return _this.cacheService.add(_this.serviceName, propertyId, true); });
                        return [2 /*return*/, comps];
                }
            });
        });
    };
    CompsService.prototype.byLeasedSpaces = function (propertyIds) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var uncachedPropertyIds, cachedComps, params, comps;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uncachedPropertyIds = propertyIds.filter(function (propertyId) { return !_this.cacheService.get(_this.serviceName, propertyId); });
                        cachedComps = this.cacheService.getAll(this.serviceName).filter(function (comp) {
                            return comp.spacePropertyId && propertyIds.includes(comp.spacePropertyId);
                        });
                        if (!uncachedPropertyIds.length) {
                            return [2 /*return*/, Promise.resolve(cachedComps)];
                        }
                        params = {
                            where: {
                                spacePropertyId: {
                                    $in: uncachedPropertyIds
                                }
                            }
                        };
                        return [4 /*yield*/, this.fetch(params)];
                    case 1:
                        comps = _a.sent();
                        uncachedPropertyIds.forEach(function (propertyId) { return _this.cacheService.add(_this.serviceName, propertyId, true); });
                        return [2 /*return*/, cachedComps.concat(comps)];
                }
            });
        });
    };
    CompsService.prototype.byLeasedProperties = function (propertyIds) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var uncachedPropertyIds, cachedComps, params, comps;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uncachedPropertyIds = propertyIds.filter(function (propertyId) { return !_this.cacheService.get(_this.serviceName, propertyId); });
                        cachedComps = this.cacheService.getAll(this.serviceName).filter(function (comp) {
                            return comp.leasedPropertyId && propertyIds.includes(comp.leasedPropertyId);
                        });
                        if (!uncachedPropertyIds.length) {
                            return [2 /*return*/, Promise.resolve(cachedComps)];
                        }
                        params = {
                            where: {
                                leasedPropertyId: {
                                    $in: uncachedPropertyIds
                                }
                            }
                        };
                        return [4 /*yield*/, this.fetch(params)];
                    case 1:
                        comps = _a.sent();
                        uncachedPropertyIds.forEach(function (propertyId) { return _this.cacheService.add(_this.serviceName, propertyId, true); });
                        return [2 /*return*/, cachedComps.concat(comps)];
                }
            });
        });
    };
    CompsService.prototype.createFromContract = function (contract, listingData) {
        return __awaiter(this, void 0, void 0, function () {
            var method, path, params, data, comp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        method = 'post';
                        path = '/from/contract';
                        params = __assign({}, contract, listingData);
                        return [4 /*yield*/, this.request(method, path, params)];
                    case 1:
                        data = _a.sent();
                        comp = new CompModel(data);
                        return [2 /*return*/, comp];
                }
            });
        });
    };
    CompsService.prototype.createFromContract2 = function (contract) {
        return __awaiter(this, void 0, void 0, function () {
            var method, path, params, data, comp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        method = 'post';
                        path = '/from/contract2';
                        params = contract;
                        return [4 /*yield*/, this.request(method, path, params)];
                    case 1:
                        data = _a.sent();
                        comp = new CompModel(data);
                        return [2 /*return*/, comp];
                }
            });
        });
    };
    return CompsService;
}(BaseService));
export { CompsService };
